<!-- 後端 Laravel + 前台 Inertia 範例頁 -->
<script setup>
import { usePage, useForm, Link } from '@inertiajs/vue3';
import ziggyRoute from '../ziggyRoute';

// 後端來的資料
const props = defineProps({
    ziggyConfig: Object,    // 其他頁面或API的網址資料，若頁面無需求則不存在此屬性
    pageName: String,   // 後端帶給前端使用的範例資料：「頁面名稱」
});

/**
 * 常駐的後端資料
 * 1. csrfToken: String CSRF密鑰
 * 2. authUser: null|Object 登入者個資
 */
const page = usePage();
// 發送表單範例
const form = useForm({
    // 表單欄位
});
const submitForm = () => form.transform(data => ({
    _token: page.props.csrfToken,   //  送出表單前帶入CSRF密鑰
    ...data,
})).post(
    // 表單送出的網址
    ziggyRoute(props, '後端路由名稱')
);
</script>

<template>
<div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
    <h1 class="text-white">This is {{ props.pageName }} Page.</h1>
    <Link :href="ziggyRoute(props, 'login.page')">Go to Login Page</Link>
</div>
</template>
